import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking',
    isStatic: false
  },
  asset_type: {
    name: 'Asset type',
    isStatic: false
  },
  aggregated_value_amount: {
    name: 'Aggregated value',
    isStatic: false
  },
  aggregated_value_rate: {
    name: 'Aggregated value %',
    isStatic: false
  },
  position_type: {
    name: 'Position type',
    isStatic: false
  },
  market: {
    name: 'Market',
    isStatic: true,
    description: ''
  },
  market_code_type: {
    name: 'Market type',
    isStatic: false
  },
  market_code: {
    name: 'Market code',
    isStatic: false
  },
  counterparty: {
    name: 'Counterparty (if there is one)',
    isStatic: true,
    description: ''
  },
  source_bic: {
    name: "Counterparty's BIC",
    isStatic: false
  },
  source_lei: {
    name: "Counterparty's LEI",
    isStatic: false
  },
  source_name: {
    name: "Counterparty's name",
    isStatic: false
  }
};

export function MostImportPortfolio({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    columns: columns,
    onChange: onChange,
    tables
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.MOST_IMPORTANT_PORTFOLIO,
    onChangeFund,
    schema: schema.MOST_IMPORTANT_PORTFOLIO,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.MOST_IMPORTANT_PORTFOLIO?.field_names || [],
    tableName: 'MOST_IMPORTANT_PORTFOLIO',
    order: 65,
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <StyledTables id="fca-reporttables-most-important-portfolio-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-most-important-portfolio-table-${index + 1}`}
          key={index + 'MOST_IMPORTANT_PORTFOLIO'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
